import { Container } from "react-bootstrap";
import anychart from 'anychart';
import {typeRelationsCalculator} from '../../../calculators/socionics/functions/typeRelationsCalculator'
import {whichRelationIsThis} from '../../../calculators/socionics/functions/whichRelation'
import { useEffect } from "react";
function Bar3d(){
    let scores=typeRelationsCalculator()
    let r=[]
    for(let i=0; i< scores.length;i++){
        r.push(whichRelationIsThis(scores[i]))
    }

    useEffect(() => {
        anychart.onDocumentReady(function () {
            // create data set on our data
            var chartData = {
              header: [
                '#',
                'ENTP',
                'ISFP',
                'ESFJ',
                'INTJ',
                'ENFJ',
                'ISTJ',
                'ESTP',
                'INFP',
                'ENTj',
                'ISFJ',
                'ESFP',
                'INTP',
                'ESTJ',
                'INFJ',
                'ENFP',
                'ISTP',
              ],
              rows: [
                    ['ENTP', scores[0], scores[1], scores[2], scores[3], scores[4], scores[5], scores[6], scores[7], scores[8], scores[9], scores[10], scores[11], scores[12], scores[13], scores[14], scores[15]],
                    ['ISFP', scores[16], scores[17], scores[18], scores[19], scores[20], scores[21], scores[22], scores[23], scores[24], scores[25], scores[26], scores[27], scores[28], scores[29], scores[30], scores[31]],
                    ['ESFJ', scores[32], scores[33], scores[34], scores[35], scores[36], scores[37], scores[38], scores[39], scores[40], scores[41], scores[42], scores[43], scores[44], scores[45], scores[46], scores[47]],
                    ['INTJ', scores[48], scores[49], scores[50], scores[51], scores[52], scores[53], scores[54], scores[55], scores[56], scores[57], scores[58], scores[59], scores[60], scores[61], scores[62], scores[63]],
                    ['ENFJ', scores[64], scores[65], scores[66], scores[67], scores[68], scores[69], scores[70], scores[71], scores[72], scores[73], scores[74], scores[75], scores[76], scores[77], scores[78], scores[79]],
                    ['ISTJ', scores[80], scores[81], scores[82], scores[83], scores[84], scores[85], scores[86], scores[87], scores[88], scores[89], scores[90], scores[91], scores[92], scores[93], scores[94], scores[95]],
                    ['ESTP', scores[96], scores[97], scores[98], scores[99], scores[100], scores[101], scores[102], scores[103], scores[104], scores[105], scores[106], scores[107], scores[108], scores[109], scores[110], scores[111]],
                    ['INFP', scores[112], scores[113], scores[114], scores[115], scores[116], scores[117], scores[118], scores[119], scores[120], scores[121], scores[122], scores[123], scores[124], scores[125], scores[126], scores[127]],
                    ['ENTj', scores[128], scores[129], scores[130], scores[131], scores[132], scores[133], scores[134], scores[135], scores[136], scores[137], scores[138], scores[139], scores[140], scores[141], scores[142], scores[143]],
                    ['ISFJ', scores[145], scores[146], scores[147], scores[148], scores[149], scores[150], scores[151], scores[152], scores[153], scores[154], scores[155], scores[156], scores[157], scores[158], scores[159], scores[160]],
                    ['ESFP', scores[161], scores[162], scores[163], scores[164], scores[165], scores[166], scores[167], scores[168], scores[169], scores[170], scores[171], scores[172], scores[173], scores[174], scores[175], scores[176]],
                    ['INTP', scores[177], scores[178], scores[179], scores[180], scores[181], scores[182], scores[183], scores[184], scores[185], scores[186], scores[187], scores[188], scores[189], scores[190], scores[191], scores[192]],  
                    ['ESTJ', scores[193], scores[194], scores[195], scores[196], scores[197], scores[198], scores[199], scores[200], scores[201], scores[202], scores[203], scores[204], scores[205], scores[206], scores[207], scores[208]],
                    ['INFJ', scores[209], scores[210], scores[211], scores[212], scores[213], scores[214], scores[215], scores[216], scores[217], scores[218], scores[219], scores[220], scores[221], scores[222], scores[223], scores[224]],
                    ['ENFP', scores[225], scores[226], scores[227], scores[228], scores[229], scores[230], scores[231], scores[232], scores[233], scores[234], scores[235], scores[236], scores[237], scores[238], scores[239], scores[240]], 
                    ['ISTP', scores[241], scores[242], scores[243], scores[244], scores[245], scores[246], scores[247], scores[248], scores[249], scores[250], scores[251], scores[252], scores[251], scores[252], scores[253], scores[254]],
                ]
    
          };
            // create column chart
            var chart = anychart.column3d();
            // set chart data
            chart.data(chartData);
            // turn on chart animation
            chart.animation(false);
            chart.yAxis().labels().format('{%Value}{groupsSeparator: }');
            // set titles for Y-axis
            chart.yAxis().title('Compatibility Strength'); 
            // turn on legend
            chart.legend().enabled(true).fontSize(10).padding([0, 0, 20, 0]);
            // set interactivity settings
            chart.interactivity().hoverMode('single');
    
            // set tooltip settings
            chart
                .tooltip()
                .positionMode('point')
                .position('center-top')
                .anchor('center-bottom')
                .offsetX(0)
                .offsetY(10)
                .format('{%SeriesName}: {%Value}{groupsSeparator: }');
    
            // set 3D settings
            chart.zAspect('10%').zPadding(30).zAngle(75).zDistribution(true);
    
            // set container id for the chart
            chart.container('chartholder');
    
            // initiate chart drawing
            chart.draw();
        });
      },[scores])


    return(
        <Container fluid id="chartholder" className='py-4' style={{height:'850px'}}>
                  
        </Container>
    )
}

export default Bar3d;